__turbopack_context__.v({
  "message": "LoaderInterstitial-module__1ZLycW__message",
  "root": "LoaderInterstitial-module__1ZLycW__root",
});
